var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-r"},[(_vm.loading)?_c('div',{staticClass:"card"},[_c('loading-animation'),_vm._v(" Loading data ")],1):_c('Canvas',{attrs:{"json":_vm.json},on:{"save":_vm.onSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }